export default function VideoButtonPlayIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <path d="M11.29 23.573c.395 0 .737-.123 1.186-.386l10.467-6.065c.783-.457 1.143-.844 1.143-1.459 0-.615-.36-1.002-1.143-1.459L12.476 8.14c-.449-.255-.791-.387-1.187-.387-.773 0-1.362.589-1.362 1.556v12.717c0 .958.589 1.547 1.362 1.547z" fill="#FFF" fillRule="nonzero" />
      </g>
    </svg>
  );
};
